// Constants for data mapping
const INCOME_TYPE_MAP = {
    "Current Income": 330,
    "Previous Income": 331,
    "Additional Income": 332,
    "Alimony": 333,
    "Child Support": 334,
    "Retirement": 335,
    "Social Security": 336,
    "Other": 337,
    "Unemployed": 2193,
};

const COMMUNICATION_METHOD_MAP = {
    "Call Home Phone": 765,
    "Call Mobile Phone": 1773,
    "Call Work Phone": 1772,
    "Text Mobile": 2050868,
    "Email": 764,
};

const STATE_ID_MAP = {
    "Alabama": 340, "Alaska": 341, "APO/FPO (ZIP 090xx - 098xx)": 342,
    "APO/FPO (ZIP 340xx)": 343, "APO/FPO (ZIP 962xx - 966xx)": 344,
    "Arizona": 345, "Arkansas": 346, "California": 347, "Colorado": 348,
    "Connecticut": 349, "Delaware": 350, "District of Columbia": 351,
    "Florida": 352, "Georgia": 353, "Hawaii": 354, "Idaho": 355,
    "Illinois": 356, "Indiana": 357, "Iowa": 358, "Kansas": 359,
    "Kentucky": 360, "Louisiana": 361, "Maine": 362, "Maryland": 363,
    "Massachusetts": 364, "Michigan": 365, "Minnesota": 366,
    "Mississippi": 367, "Missouri": 368, "Montana": 369, "Nebraska": 370,
    "Nevada": 371, "New Hampshire": 372, "New Jersey": 373,
    "New Mexico": 374, "New York": 375, "North Carolina": 376,
    "North Dakota": 377, "Ohio": 378, "Oklahoma": 379, "Oregon": 380,
    "Pennsylvania": 381, "Rhode Island": 382, "South Carolina": 383,
    "South Dakota": 384, "Tennessee": 385, "Texas": 386, "Utah": 387,
    "Vermont": 388, "Virginia": 389, "Washington": 390,
    "West Virginia": 391, "Wisconsin": 392, "Wyoming": 393,
    "Puerto Rico": 5851, "American Samoa": 9995, "Micronesia": 9996,
    "Guam": 9997, "Marshall Islands": 9998,
    "Northern Mariana Islands": 9999, "Palau": 10000,
    "U.S. Minor Outlying Islands": 10001, "U.S. Virgin Islands": 10002,
};

const RESIDENCE_STATUS_MAP = {
    "Own": 314,
    "Own - Free & Clear": 314,
    "Rent": 315,
    "Living with Parents": 316,
    "Living with Others": 316,
    "Goverment Quarters": 317,
    "Other": 317,
    "Mortgage": 1763,
    "Buy/Own with Mortgage": 1763,
};

const LOAN_TYPE_MAP = {
    "Auto Loan": 2050463,  // Default to New Vehicle code for Auto Loan
    "New Vehicle": 2050463,
    "Used Vehicle": 2050467,
    "Unsecured Loan Application": 2050457,
    "Platinum Visa Application": 2051878,
    "Smart Rewards Application": 2051880,
    "MAX Signature Application": 2051877,
};

const UNSECURED_PURPOSE_MAP = {
    "Consolidation": 2050464,
    "For relatives": 2050456,
    "Holiday": 2050453,
    "Home repair": 2050477,
    "Household goods": 2050466,
    "Legal": 2050476,
    "Medical": 2050455,
    "Other": 2050457,
    "PC system": 2050450,
    "Taxes": 2050475,
    "Vacation": 2050454,
    "Wedding": 2050478,
};

const LOAN_TYPE_TO_FCCTYPE = {
    "MAX Signature Application": 2050986,
    "Platinum Visa Application": 2050983,
    "Secured Visa Application": 2050984,
    "Smart Rewards Application": 2050985
};

const FSUBPROD_MAP = {
    "Auto Loan": 10014,    // Auto loans always map to 10014
    "New Vehicle": 10014,
    "Used Vehicle": 10014,
    "Unsecured Loan Application": 10034,
    "Platinum Visa Application": 10006,
    "Smart Rewards Application": 10006,
    "MAX Signature Application": 10006,
};

// Helper functions
const formatSSN = (ssn) => {
    // Implement SSN formatting if needed
    return ssn;
};

const calculateAge = (birthDate) => {
    if (!birthDate) return 0;
    try {
        const dob = new Date(birthDate);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age;
    } catch (e) {
        return 0;
    }
};

// Helper function to get loan type ID
const getLoanTypeId = (loanType) => {
    return LOAN_TYPE_MAP[loanType] || 0;
};

// Helper function to get unsecured purpose code
const getUnsecuredPurposeCode = (purpose) => {
    return UNSECURED_PURPOSE_MAP[purpose] || 2050457; // Default to Other
};

// Helper function to get subproduct ID
const getSubproductId = (loanType) => {
    return FSUBPROD_MAP[loanType] || 0;
};

// Helper functions for data transformation
const formatDate = (dateString) => {
    if (!dateString) return "";
    // Create date in UTC to avoid timezone issues
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
};

const getStateCode = (stateName) => {
    const STATE_ID_MAP = {
        "Alabama": 340, "Alaska": 341, "APO/FPO (ZIP 090xx - 098xx)": 342,
        "APO/FPO (ZIP 340xx)": 343, "APO/FPO (ZIP 962xx - 966xx)": 344,
        "Arizona": 345, "Arkansas": 346, "California": 347, "Colorado": 348,
        "Connecticut": 349, "Delaware": 350, "District of Columbia": 351,
        "Florida": 352, "Georgia": 353, "Hawaii": 354, "Idaho": 355,
        "Illinois": 356, "Indiana": 357, "Iowa": 358, "Kansas": 359,
        "Kentucky": 360, "Louisiana": 361, "Maine": 362, "Maryland": 363,
        "Massachusetts": 364, "Michigan": 365, "Minnesota": 366,
        "Mississippi": 367, "Missouri": 368, "Montana": 369, "Nebraska": 370,
        "Nevada": 371, "New Hampshire": 372, "New Jersey": 373,
        "New Mexico": 374, "New York": 375, "North Carolina": 376,
        "North Dakota": 377, "Ohio": 378, "Oklahoma": 379, "Oregon": 380,
        "Pennsylvania": 381, "Rhode Island": 382, "South Carolina": 383,
        "South Dakota": 384, "Tennessee": 385, "Texas": 386, "Utah": 387,
        "Vermont": 388, "Virginia": 389, "Washington": 390,
        "West Virginia": 391, "Wisconsin": 392, "Wyoming": 393,
        "Puerto Rico": 5851, "American Samoa": 9995, "Micronesia": 9996,
        "Guam": 9997, "Marshall Islands": 9998,
        "Northern Mariana Islands": 9999, "Palau": 10000,
        "U.S. Minor Outlying Islands": 10001, "U.S. Virgin Islands": 10002
    };
    return STATE_ID_MAP[stateName] || "";
};

const getResidenceStatusCode = (status) => {
    const RESIDENCE_STATUS_MAP = {
        "Own": 314,
        "Own - Free & Clear": 314,
        "Rent": 315,
        "Living with Others": 316,
        "Goverment Quarters": 317,
        "Other": 317,
        "Mortgage": 1763,
        "Buy/Own with Mortgage": 1763
    };
    return RESIDENCE_STATUS_MAP[status] || 316; // Default to "Living with Parents/Others"
};

const getIncomeFrequencyCode = (frequency) => {
    const INCOME_FREQUENCY_MAP = {
        "Weekly": 329,
        "Bi-Weekly": 326,
        "Bi-Monthly": 325,
        "Monthly": 327,
        "Quarterly": 328,
        "Annually": 324,
        "Hourly": 714
    };
    return INCOME_FREQUENCY_MAP[frequency] || 327; // Default to Monthly
};

const getContactPreferenceCode = (preference) => {
    const CONTACT_PREFERENCE_MAP = {
        "Home Phone": 765,
        "Work Phone": 1772,
        "Mobile Phone": 1773,
        "Email": 764,
        "Text": 2050868
    };
    return CONTACT_PREFERENCE_MAP[preference] || 764; // Default to Email
};

// Define all possible fields with their mappings
const form_to_dda_key_map = {
    // Loan Details
    requestedAmount: "freqamt",
    loanTerm: "fterm",
    loan_type: "fpurposecd",
    subprod: "fsubprod",

    // Personal Information
    firstName: "fname",
    middleName: "mname",
    lastName: "lname",
    suffix: "fsuffix",
    birthDate: "fdob",
    ssn: "ftin",

    // Address Information
    addressLine1: "faddr1",
    addressLine2: "faddr2",
    city: "fcity",
    state: "fstate",
    zipCode: "fzipcode",
    housingStatus: "faddrstatus",
    monthlyPayment: "fexpense",

    // Income Information
    employmentYears: "fincyear",
    employmentMonths: "fincmonth",
    incomeSource: "fincsource",
    occupation: "finctitle",
    incomeFrequency: "fincfreq",
    incomeAmount: "fincamt",

    // Additional Income
    additionalIncomeYears: "fprevempyrs",
    additionalIncomeMonths: "fprevempmths",
    additionalIncomeSource: "fadlincsrc",
    additionalIncomeType: "fadlinctype",
    additionalIncomeFrequency: "fadlincfreq",
    additionalIncomeAmount: "fadlincamt",

    // Contact Information
    homePhone: "fhomephone",
    mobilePhone: "fmobilephone",
    workPhone: "fworkphone",
    email: "femail",
    preferredContact: "fcontact",

    // Vehicle Information
    vin: "fvin",
    year: "fyear",
    make: "fmake",
    model: "fmodel",
    trim: "fsubmodel",
    mileage: "fmileage",
    gapInsurance: "fcnxaccptgap",
    estimatedValue: "fcolvalue",

    // Additional fields
    cctype: "fcctype",
    campcode: "fcnxstcampcode"
};

export const transformFormDataToDDA = (formData) => {
    // Create the DDA dictionary with the required structure
    const dda_dict = {
        actioncode: "Q2TRAFFICCOP",
        data: {
            actioncode: "Q2TRAFFICCOP",
            objectvalue: {
                fielditems: []
            }
        }
    };

    // Helper function to add a field to the fielditems array
    const addField = (key, value) => {
        dda_dict.data.objectvalue.fielditems.push({
            data: value,
            dtopath: "",
            key: key
        });
    };

    // Add all required fields in the exact order with correct data types
    const requiredFields = [
        { key: "freqamt", value: formData.requestedAmount || "" },
        { key: "fterm", value: formData.loanTerm || "" },
        { key: "fpurposecd", value: formData.loan_type === "Unsecured Loan Application" ? 
            getUnsecuredPurposeCode(formData.unsecuredLoanPurpose) : 
            (formData.loan_type === "Auto Loan" ? 2050463 : 
            (formData.loan_type === "MAX Signature Application" ? 2051877 :
            (formData.loan_type === "Platinum Visa Application" ? 2051878 :
            (formData.loan_type === "Smart Rewards Application" ? "2051880" : "")))) },
        { key: "fsubprod", value: formData.loan_type === "Unsecured Loan Application" ? 
            10034 : 
            (formData.loan_type === "Auto Loan" ? 10014 :
            (formData.loan_type === "MAX Signature Application" ? 10006 :
            (formData.loan_type === "Platinum Visa Application" ? 10006 :
            (formData.loan_type === "Smart Rewards Application" ? 10006 : 0)))) },
        { key: "fname", value: formData.firstName || "" },
        { key: "mname", value: formData.middleName || "" },
        { key: "lname", value: formData.lastName || "" },
        { key: "fsuffix", value: formData.suffix || "" },
        { key: "fdob", value: formData.birthDate ? formatDate(formData.birthDate) : "" },
        { key: "fage", value: "" },
        { key: "ftin", value: formData.ssn || "" },
        { key: "faddr1", value: formData.addressLine1 || "" },
        { key: "faddr2", value: formData.addressLine2 || "" },
        { key: "fcity", value: formData.city || "" },
        { key: "fstate", value: formData.state ? getStateCode(formData.state) : "" },
        { key: "fzipcode", value: formData.zipCode || "" },
        { key: "faddrstatus", value: formData.housing ? getResidenceStatusCode(formData.housing) : "" },
        { key: "fexpense", value: formData.housingPayment || "0" },
        { key: "fincsource", value: formData.incomeSource || "" },
        { key: "finctitle", value: formData.occupation || "" },
        { key: "fincfreq", value: formData.incomeFrequency ? String(getIncomeFrequencyCode(formData.incomeFrequency)) : "" },
        { key: "fincamt", value: formData.incomeAmount || "" },
        { key: "fprevemp", value: "" },
        { key: "fprevemployer", value: "" },
        { key: "fprevempyrs", value: "" },
        { key: "fprevempmths", value: "" },
        { key: "fadlinc", value: formData.additionalIncomeSource ? 1 : 0 },
        { key: "fadlincsrc", value: formData.additionalIncomeSource || "" },
        { key: "fadlinctype", value: formData.additionalIncomeType ? String(INCOME_TYPE_MAP[formData.additionalIncomeType] || "337") : "337" },
        { key: "fadlincfreq", value: formData.additionalIncomeFrequency ? String(getIncomeFrequencyCode(formData.additionalIncomeFrequency)) : "" },
        { key: "fadlincamt", value: formData.additionalIncomeAmount || 0 },
        { key: "fhomephone", value: formData.homePhone || "" },
        { key: "fmobilephone", value: formData.mobilePhone || "" },
        { key: "fworkphone", value: formData.workPhone || "" },
        { key: "femail", value: formData.email || "" },
        { key: "fcctype", value: String(LOAN_TYPE_TO_FCCTYPE[formData.loan_type] || "") },
        { key: "fvin", value: formData.vin || "" },
        { key: "fyear", value: formData.year || "" },
        { key: "fmake", value: formData.make || "" },
        { key: "fmodel", value: formData.model || "" },
        { key: "fsubmodel", value: formData.trim || "" },
        { key: "fmileage", value: formData.mileage || 0 },
        { key: "fcolvalue", value: formData.estimatedValue || 0 },
        { key: "fcnxaccptgap", value: formData.gapInsurance ? "true" : "false" },
        { key: "fcnxgapval", value: 0 },
        { key: "fcnxinvapply", value: "" },
        { key: "fcnxpreapprove", value: "" },
        { key: "fcnxstcampcode", value: "Q424" },
        { key: "fincyear", value: formData.employmentYears || "" },
        { key: "fincmonth", value: formData.employmentMonths || "" },
        { key: "fcontact", value: formData.preferredContact ? getContactPreferenceCode(formData.preferredContact) : 764 }
    ];

    // Add all fields in the correct order
    requiredFields.forEach(field => {
        addField(field.key, field.value);
    });

    return dda_dict;
}; 